import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation, withTranslation } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";
import AvFieldSelect from "components/Common/AvFieldSelect";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useModal from "hooks/useModal";
import { showErrorNotification } from "store/notifications/actions";
import { downloadInvestorsAPI } from "apis/mam-profile";

function DownloadInvestors({ profileId, clientId }) {
  const dispatch = useDispatch();
  const [show, toggle] = useModal(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const fileTypes = [
    "csv", "pdf", "xlsx"
  ];

  return (
    <React.Fragment >
      <div>
        <button
          type="button"
          className="btn btn-primary waves-effect waves-light w-100 me-1"
          onClick={toggle}
        >
          {t("Download")}
        </button>
      </div>
      <Modal isOpen={show} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>
          {t("Download")}
        </ModalHeader>
        <ModalBody >
          <AvForm onValidSubmit={(e, v) => {
            setLoading(true);
            downloadInvestorsAPI({
              customerId: clientId,
              fileType: v.fileType,
              profileId,
            }).then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `investors.${v.fileType}`
              );
              document.body.appendChild(link);
              link.click();
              setLoading(false);
            }).catch((error) => {
              dispatch(showErrorNotification(error?.message || t("Download failed")));
              setLoading(false);
            });
          }} >
            <AvFieldSelect
              name="fileType"
              label={t("File Type")}
              options={fileTypes.length > 0
                ? fileTypes.map((type) => {
                  return {
                    value: type,
                    label: type.toUpperCase()
                  };
                }) : ""
              }
              required
            />
            <ModalFooter className="d-flex justify-content-center pb-0">
              <Button type="submit" color="primary" 
                disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : t("Download")}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment >
  );
}

export default withTranslation()(DownloadInvestors);